import React, { useEffect, useState } from "react";
import getUserService from "../../../../services/getUser";
import { toast } from "react-toastify";
import { CustomerService } from "../../../../services/CustomerService";
import Select from "../../../../components/Atomes/Select/Select";
import BookingService from "../../../../services/BookingService";
import MbeBookSlotSlider from "../../../../components/Molecules/BookSlot/MbeBookSlotSlider";
import { ArchService } from "../../../../services/ArchService";
import { useAuth } from "../../../../services/useAuth";
import PopUpCustomerCalendar from "../../../../components/Molecules/PopUp/PopUpCustomerCalendar";

const CalendarCustomer = ({}) => {
  const [region, setRegion] = useState("");
  const [isProjectSelected, setIsProjectSelected] = useState(false);
  const [projectSelected, setProjectSelected] = useState("");
  const [projects, setProjects] = useState([]);
  const [bookings, setBookings] = useState([]);

  const [showPopUp, setShowPopUp] = useState(false);

  const [page, setPage] = useState(1);
  const [firstLoad, setFirstLoad] = useState(true);

  const { role } = useAuth();

  const selectProject = (e) => {
    if (e.target.value !== "Choisir un projet") {
      const myProject = projects.filter(
        (projet) => projet.id == e.target.value
      )[0];
      setRegion(myProject.region);
      setIsProjectSelected(true);
      setProjectSelected({
        id: e.target.value,
        projectIri: "/api/projects/" + e.target.value,
        longVisit: myProject.visitType ? myProject.visitType : null,
      });

      setBookings([]);
      setPage(1);
    } else {
      setFirstLoad(true);
      setBookings([]);
      setPage(1);
      setIsProjectSelected(false);
    }
  };

  const getProjects = async () => {
    let request;
    if (role.includes("ROLE_ARCH")) {
      request = await ArchService.getProjects({ pagination: "false" });
    } else {
      request = await CustomerService.getProjects({ pagination: "false" });
    }

    if (request.request.status === 200) {
      let datas = request.data["member"];
      if (datas.length > 0) {
        const filteredDatas = datas.filter((project) => !project.canceledAt);
        if (filteredDatas.length > 0) {
          setProjects(filteredDatas);
          const firstProject = filteredDatas[0];

          setRegion(firstProject.region);
          setIsProjectSelected(true);
          setProjectSelected({
            id: firstProject.id,
            projectIri: "/api/projects/" + firstProject.id,
            longVisit: firstProject.visitType ? firstProject.visitType : null,
          });
        } else {
          setProjects([]);
          toast.error("Aucun projet valide n'a été trouvé");
        }
      } else {
        setProjects([]);
        toast.error("Aucun projet n'a été trouvé");
      }
    }
  };

  useEffect(() => {
    getProjects();
  }, []);

  useEffect(() => {
    const getBookings = async () => {
      const request = await BookingService.getBookings({
        region: region,
        page: 1,
        "project.id": projectSelected.id,
        longVisit: projectSelected.longVisit
          ? projectSelected.longVisit
          : "false",
      });
      if (request.request.status === 200) {
        setBookings(request.data.shifts);
      } else {
        toast.error(
          "Une erreur est survenue lors de la récupération de la liste des Bookings"
        );
      }
    };
    getBookings();
  }, [projectSelected]);

  const loadMoreBookings = async () => {
    if (firstLoad) {
      setFirstLoad(false);
      return;
    }

    if (page >= 5) return;
    const nextPage = page + 2;
    setPage(nextPage);

    let request = await BookingService.getBookings({
      region: region,
      "project.id": projectSelected.id,
      longVisit: projectSelected.longVisit
        ? projectSelected.longVisit
        : "false",
      page: nextPage,
    });

    if (request.request.status === 200) {
      setBookings((prev) => [...prev, ...request.data.shifts]);
    }
  };

  useEffect(() => {
    if (region === "BDX" || region === "LYO" || region === "MAR") {
      setShowPopUp(true);
    } else {
      setShowPopUp(false);
    }
  }, [projectSelected]);

  return (
    <div className="mbe-bookingSlot-container">
      <div className="mbe-bookingSlot-steps-selectProject error-calendar-customer">
        <p className={"text-primary color-dark-grey"}>
          Sélectionner votre projet
        </p>
        <Select
          defaultValue={"Choisir un projet"}
          styleSelect={"select-custom-secondary"}
          selectedValue={projectSelected?.id || ""}
          data={
            projects &&
            projects.map((project) => {
              return (
                project.address.street +
                ", " +
                project.address.nicePostcode +
                ", " +
                project.address.city +
                " - " +
                project.reference
              );
            })
          }
          value={
            projects &&
            projects.map((project) => {
              return project.id;
            })
          }
          onChange={selectProject}
        />
      </div>
      {showPopUp && (
        <PopUpCustomerCalendar onClick={() => setShowPopUp(false)} />
      )}
      {isProjectSelected && (
        <MbeBookSlotSlider
          bookings={bookings}
          bookingSlotCreator={false}
          isCustomer={region === "BDX" || region === "LYO" || region === "MAR"}
          onReachEnd={loadMoreBookings}
        />
      )}
    </div>
  );
};

export default CalendarCustomer;
